import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import JVLayer from "../../components/Accounts/JVLayer";

const JVPage = () => {
  return (
    <MasterLayout>
      <JVLayer />
    </MasterLayout>
  );
};

export default JVPage;
